import gql from 'graphql-tag'

const query = gql`
query listClosings($filter: closingsFilterArgs, $params: ListQueryArgs) {
	cashAssist {
		listClosings(filter: $filter, params: $params) {
			total
			totalAmount
			hasNextPage
    		items {
				id
				total
				dateTime
				number
				inactive
				clientCount
				productCount
				cancellationsCount
				clientCardValue
				billNumStart
				billNumEnd
				moneyCountDateTime
				doorCounter
				guestsCount
				dateInterval {
					from
					to
				}
				cashRegister {
					id
					name
				}
				salesGroups {
					id
					amount
					total
					netto
					mWStNormal
					mWStReduced
					mWStFree
					mWStSpecial
					discount
					reduction
					salesGroup {
						id
						name
						acountNum
					}
				}
				currency {
					amount
					amountConverted
					cashInTransit
					difference
					exchangeRate
					name
					present
					presentConverted
					stock_amount
				}
				paymentMethods {
					count
					name
					amount
				}
				cardSchemes {
					id
					name: cardSchemeName
					amount: cardSchemeValue
					count: cardSchemeTransactionCount
				}
				coupons {
					amount
					count
					name
				}
				specialSales {
					amount
					count
					name
				}
				taxes {
					percent
					sales
					total
					MWSt
				}
				cashbook {
					have
					should
					description
				}
				users {
					id
					user {
						id
						name
						code
					}
					total
					clientCount
					averageBill
					userEfficiency
					cancellationsCount
					cancellationsAmount
					buttonOpenCount
					buttonBackCount
					buttonDelCount
					buttonDelAmount
					inCafeCount
					inCafeAmount
					inCafePercent
					tipsTotal
				}
	    	}
		}
	}
}`

export default query
